import React from 'react';
import { Chip } from '@mui/material';

/**
 * Ortak durum etiketi (Faz 8 UI primitifi).
 * MUI Chip'i standart yuvarlaklık + kalınlıkla sarar; renk/etiket çağrı tarafından gelir.
 * NOT: MUI 5'te geçersiz `variant="soft"` KULLANMA (yalnızca 'filled' | 'outlined').
 *
 * @param {string} label   Etiket metni
 * @param {string} color   MUI renk: 'default'|'primary'|'secondary'|'success'|'warning'|'error'|'info'
 * @param {string} size    'small' | 'medium'
 * @param {string} variant 'filled' | 'outlined'
 */
const StatusChip = ({ label, color = 'default', size = 'small', variant = 'filled', sx = {}, ...props }) => (
    <Chip
        label={label}
        color={color}
        size={size}
        variant={variant}
        sx={{ borderRadius: 1.5, fontWeight: 600, ...sx }}
        {...props}
    />
);

export default StatusChip;
